<template>
  <div class="regist">
    <div class="title">找回密码</div>
    <van-form style="margin-top: 20px;">
      <van-field v-model.trim="phoneNumber" name="phoneNumber" placeholder="手机号" />

      <div class="img-container">
        <van-field v-model.trim="checkCode" name="code" placeholder="图像验证码"></van-field>
        <img @click="initCodeImg" style="width:78px;height:32px" :src="codeUrl" alt="" />
      </div>

      <van-field v-model.trim="code" name="code" placeholder="短信验证码">
        <template #button>
          <van-button @click="handleSendCode" v-if="!showCount" size="small" type="info">发送验证码</van-button>
          <van-count-down @finish="showCount = false" v-else :time="time" format="ss秒" />
        </template>
      </van-field>
      <van-button style="margin-top: 20px;" round block type="info" @click="onSubmit">
        下一步
      </van-button>
    </van-form>
  </div>
</template>

<script>
import {checkPhoneNumber} from '@/ultis'
import {smsSendModifyPwd, smsVerifyCode, getCodeImg} from '@/api'
export default {
  data() {
    return {
      phoneNumber: '',
      code: '',
      checkCode: '',
      checkCodeSessionId: '',
      codeUrl: '',
      time: 60 * 1000,
      showCount: false
    }
  },
  created() {
    this.initCodeImg()
  },
  methods: {
    // 获取图形验证码
    initCodeImg() {
      getCodeImg().then(res => {
        const {checkCodeImageData, checkCodeSessionId} = res.data
        this.checkCodeSessionId = checkCodeSessionId
        this.codeUrl = checkCodeImageData
      })
    },
    onSubmit() {
      if (!checkPhoneNumber(this.phoneNumber)) {
        return this.$Toast.fail('输入正确的手机号')
      }
      if (!this.code) {
        return this.$Toast.fail('请输短信验证码')
      }
      if (!this.checkCode) {
        return this.$Toast.fail('请输图形验证码')
      }
      const params = {
        phone: this.phoneNumber,
        smsCode: this.code,
        checkCodeSessionId: this.checkCodeSessionId,
        checkCode: this.checkCode
      }
      smsVerifyCode(params).then(res => {
        if (res.success) {
          const {verifyId} = res.data
          this.$router.push({
            path: '/resetPwd',
            query: {
              verifyId
            }
          })
        } else {
          this.$Toast.fail(res.msg)
        }
      })
    },
    // 发短信
    handleSendCode() {
      if (!checkPhoneNumber(this.phoneNumber)) {
        return this.$Toast.fail('输入正确的手机号')
      }
      smsSendModifyPwd({phone: this.phoneNumber}).then(res => {
        this.showCount = true
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.regist {
  min-height: 100vh;
  background: #fff;
  padding: 20px;
}
.title {
  font-size: 20px;
  font-weight: 700;
}
.img-container {
  position: relative;
  img {
    position: absolute;
    right: 16px;
    top: 5px;
  }
}
</style>
